export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_LANGUAGE = 'en';
export const YU_LANGUAGES = ['sr', 'cnr'];